import React, { useState, memo, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import { DragDropContext } from 'react-beautiful-dnd'
import { withStyles } from '@material-ui/core/styles'

import { useDispatch } from 'react-redux'
import { SearchInput } from 'Components/Header/SearchInput'
import Progress from 'Components/Progress'
import PipelineColumn from './components/PipelineColumn'
import { SnackBarContext } from 'Components/SnackBar'
import { apiClient } from '../../../../../Module/API/Client'
import { updateCampaignExtraData } from '../../../../Campaigns/Page/Codes/gql/updateCampaignInternalStatus'

import {
  showReduxModal,
  hideReduxModal,
  resetReduxModal,
} from 'Reducers/UI/actions'

import {
  filterPipelines,
  formatDate,
  isHasCity,
  isHasSearch,
  onExportData,
  openLinkInNewTab,
  splitEmails,
  getCampaignBuilderPageUrl,
  getDashboardPageUrl,
  getClientDashboardPageUrl,
  getDigitalProofPageUrl,
  getCodesPageUrl,
  addAuthParamsToCampaignBuilderUrl,
  setUrl,
  convertCityNameToValue,
  getUniqueCities,
  saveCustomLocations,
} from './utils'

import {
  CAMPAIGN_BUILDER_CARD_OPTIONS,
  CAMPAIGN_CARD_ACTIONS,
  campaignCardOptions,
  DEFAULT_FILTER_OPTION,
  EMAIL_TYPE,
} from './options'

import style from './style'
import { SelectDashboard } from '../../../../../Components/Form'
import { Grid } from '@material-ui/core'
import {
  createEDDMInternalFlyerCodes,
  createCityPlanAndMissionOnSSCampaign,
  getCampaignFlyerInfo,
  getClientById,
  sendEmail,
  updateCampaignsCampaignBuilderData,
  updateSelfServeCampaignData,
  getDataByChunks,
} from './graphQL'
import { updateCampaign } from '../../../../../Module/graphQL'
import {
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_LOG_ENUM_TYPES,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
} from '../../../../../shared/constants'
import EmailModal from './components/EmailModal'
import { authorization } from '../../../../../Module/Auth/Auth'
import SubmitButton from '../../../../../Components/Form/SubmitButton'
import { urlGet } from '../../../../../Utils/URL'
import { insertCampaignLogs } from '../../../../../Logs/campaign/gql'
import { apiXero } from '../../../../../Module/API/Xero'
import { PATHS } from '../../../../../Config/Routing/paths'
import { handleConfirmationDialog } from '../../../../City/Page/Ambasadors/EmailPipelineView/utils'
import ConfirmDialog from '../../../../../Components/ConfirmDialog/ConfirmDialog'
import { getCampaignCityMetrics } from '../../../../Campaigns/CreateEditCampaign/gql'
import XeroConnected from '../../../../../Components/XeroConnected'
import { isProduction } from '../../../../../Utils/Functions'
import { CONFIG } from '../../../../../Config/config'

const CAMPAIGNS_WITH_NO_PAYMENT = [
  '1504',
  '1542',
  '1528',
  '1527',
  '1522',
  '1521',
  '1507',
  '1525',
  '2887',
]

const getClientSkipCheckoutSetting = async clientId => {
  try {
    const clientResponse = await getClientById(clientId)
    const { data: clientData } = await clientResponse.json()
    const client =
      clientData &&
      clientData.clients &&
      clientData.clients.nodes &&
      clientData.clients.nodes[0]
    return (client && client.isSkipCheckoutEnabled) || false
  } catch (error) {
    console.error('Error fetching client data:', error)
    return false
  }
}

const shouldSkipPayment = (
  subtype,
  isPaymentSkipped,
  clientIsSkipCheckoutEnabled,
) => {
  return (
    isPaymentSkipped ||
    (clientIsSkipCheckoutEnabled && subtype === CAMPAIGN_SUBTYPES_ENUM.ADM)
  )
}

const CampaignPipelineView = ({ classes, country }) => {
  const {
    id: countryId,
    name: countryName,
    currencySign,
    code: countryCode,
  } = country

  const defaultFetchArgs = {
    countryId,
    includePathfinder: true,
  }

  const origin = window.location.origin

  const user = authorization.getUser()
  const runSnackBar = useContext(SnackBarContext)

  const cityUrl = urlGet('city')
  const searchUrl = urlGet('tableSearch')

  const dispatch = useDispatch()

  const [citiesOptions, setCitiesOptions] = useState([DEFAULT_FILTER_OPTION])
  const [cityFilter, setCityFilter] = useState(
    cityUrl || citiesOptions[0].value,
  )
  const [searchValue, setSearchValue] = useState(searchUrl || null)
  const [campaignEmailData, setCampaignEmailData] = useState(null)
  const [resetSearch, setResetSearch] = useState(false)
  const [pipelines, setPipelines] = useState({
    [CAMPAIGN_INTERNAL_STATUSES.DRAFT]: [],
    [CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW]: [],
    [CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW]: [],
    [CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF]: [],
    [CAMPAIGN_INTERNAL_STATUSES.PAYMENT]: [],
    [CAMPAIGN_INTERNAL_STATUSES.ACTIVE]: [],
  })
  const [filteredPipelines, setFilteredPipelines] = useState(null)
  const [isFetchedPipelines, setIsFetchedPipelines] = useState(false)

  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(null)
  const [xeroInfo, setXeroInfo] = useState('Loading')
  const [tenant, setTenant] = useState(null)
  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })
  const [isLoadingRequest, setIsLoadingRequest] = useState(false)
  const currentClient = useSelector(state => state.clients.clientView)
  const canNavigateCampaignBuilder =
    !authorization.isClient() ||
    (currentClient && currentClient.isSelfServeEnabled)

  const isXeroAvailable = apiXero.isHaveXeroAccess()

  const fetchTenant = async () => {
    const result = await apiXero.getXeroTenant()
    if (result && result.isAuthorized && result.isConnected) {
      setTenant(result)
      setXeroInfo(`Entity - ${result.name}`)
    } else {
      setXeroInfo('')
    }
  }

  useEffect(() => {
    fetchInitalData()
  }, [])

  const fetchInitalData = async () => {
    setIsLoading(true)
    setData(null)
    const campaignsByChunks = await getDataByChunks(defaultFetchArgs)
      .then(x => x.json())
      .then(x => x.data.campaignsBuilderData.nodes)
    setData(campaignsByChunks)
    try {
      await fetchTenant()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log({ error })
      setXeroInfo('Something went wrong')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!isLoading) {
      const cities = []
      setPipelines(
        data.reduce(
          (acc, item) => {
            // Don't show Inserts campaign's on campaign pipeline.
            if (item.type === CAMPAIGN_ENUM_TYPES.INSERTS) {
              return acc
            }

            // TODO: ADD REJECTED COLUMN?? OR AT LEAST A REJECTED LABEL IN THE CARD?
            if (
              Object.keys(acc).includes(item.internalStatus) ||
              item.internalStatus === CAMPAIGN_INTERNAL_STATUSES.REJECTED
            ) {
              if (item.internalStatus) {
                cities.push(item.cityName)
                const newItemData = {
                  ...item,
                  createdDate: formatDate(item.createdAt),
                  startDate: formatDate(item.startDate),
                  submitDate: formatDate(item.submitDate),
                  internalStatusChangedDate: formatDate(
                    item.internalStatusChangedDate,
                  ),
                  totalCosts:
                    typeof item.totalCosts === 'number'
                      ? `${currencySign}${item.totalCosts}`
                      : '-',
                  taxes:
                    typeof item.taxes === 'number'
                      ? `${currencySign}${item.taxes}`
                      : '-',
                  submitter: item.submitter
                    ? `${item.submitter.firstName} ${item.submitter.lastName}`
                    : '-',
                }
                if (
                  item.internalStatus === CAMPAIGN_INTERNAL_STATUSES.REJECTED
                ) {
                  // TODO: ADD REJECTED COLUMN?? OR AT LEAST A REJECTED LABEL IN THE CARD?
                  acc[CAMPAIGN_INTERNAL_STATUSES.DRAFT].push(newItemData)
                } else {
                  acc[item.internalStatus].push(newItemData)
                }
              }
            }
            return acc
          },
          {
            [CAMPAIGN_INTERNAL_STATUSES.DRAFT]: [],
            [CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW]: [],
            [CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW]: [],
            [CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF]: [],
            [CAMPAIGN_INTERNAL_STATUSES.PAYMENT]: [],
            [CAMPAIGN_INTERNAL_STATUSES.ACTIVE]: [],
          },
        ),
      )

      const onlyUniqCity = getUniqueCities(cities)

      const convertedToOptions = onlyUniqCity.map(name => ({
        label: name,
        value: convertCityNameToValue(name),
      }))

      setCitiesOptions(prev => [...prev, ...convertedToOptions])
      setIsFetchedPipelines(true)
    }
  }, [isLoading])

  useEffect(() => {
    if (isFetchedPipelines) {
      if (cityFilter && searchValue) {
        setFilteredPipelines(
          filterPipelines(pipelines, item => {
            return (
              isHasCity(item, cityFilter) &&
              (isHasSearch(item.campaignName, searchValue) ||
                isHasSearch(item.clientName, searchValue))
            )
          }),
        )
      } else if (cityFilter && !searchValue) {
        setFilteredPipelines(
          filterPipelines(pipelines, item => isHasCity(item, cityFilter)),
        )
      } else if (searchValue && !cityFilter) {
        setFilteredPipelines(
          filterPipelines(
            pipelines,
            item =>
              isHasSearch(item.campaignName, searchValue) ||
              isHasSearch(item.clientName, searchValue),
          ),
        )
      } else {
        setFilteredPipelines(null)
      }
    }
  }, [isFetchedPipelines, cityFilter, searchValue])

  const onChangeCityFilter = (e, index, value) => {
    setUrl('city', value)
    setCityFilter(value)
  }

  const handlerSearch = searchValue => {
    const trimmedSearchedValue = searchValue ? searchValue.trim() : searchValue
    setUrl('tableSearch', trimmedSearchedValue)
    setSearchValue(trimmedSearchedValue)
  }

  const onCancel = () => {
    hideReduxModal()
    resetReduxModal()
  }

  const onSubmit = async ({
    data,
    sendEmail,
    emailType,
    campaignId,
    paymentIntent,
    isPaymentSkipped,
    clientId,
    isMoveInGenerationDigitalProof,
    type,
    subtype,
  }) => {
    setIsLoadingRequest(true)

    const clientIsSkipCheckoutEnabled = await getClientSkipCheckoutSetting(
      clientId,
    )

    const skipPayment = shouldSkipPayment(
      campaignEmailData.subtype,
      isPaymentSkipped,
      clientIsSkipCheckoutEnabled,
    )
    const isDirectMail =
      campaignEmailData.subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM ||
      campaignEmailData.subtype === CAMPAIGN_SUBTYPES_ENUM.ADM

    if (emailType === EMAIL_TYPE.APPROVE_CAMPAIGN) {
      if (!isDirectMail) {
        const campaignCityMetricsData = await getCampaignCityMetrics(
          campaignEmailData.campaignId,
        )

        if (!campaignCityMetricsData.length) {
          handleConfirmationDialog({
            title: 'Restricted!',
            contentText:
              'You cannot approve campaign without filled cities metrics',
            setConfirmDialogData,
            rightButtonLable: 'OK',
          })

          setIsLoadingRequest(false)
          return
        }

        if (!tenant && isProduction()) {
          handleConfirmationDialog({
            title: 'Restricted!',
            contentText: 'You cannot approve campaign without Xero connection',
            setConfirmDialogData,
            rightButtonLable: 'OK',
          })
          setIsLoadingRequest(false)
          return
        }
      }
    }

    if (sendEmail) {
      await onSendEmail({
        ...data,
        isShowToast: ![
          EMAIL_TYPE.DECLINE_CAMPAIGN,
          EMAIL_TYPE.APPROVE_CAMPAIGN,
        ].includes(emailType),
      })
    }

    if (emailType === EMAIL_TYPE.DECLINE_CAMPAIGN) {
      try {
        if (type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
          const rejectDmResult = await handleRejectDmCampaign({
            campaignId,
            subtype,
          })
          if (rejectDmResult && !!rejectDmResult.error) {
            throw new Error(
              'There was an error while deleting Direct Mail campaign data',
            )
          }
        }
        if (!skipPayment && !CAMPAIGNS_WITH_NO_PAYMENT.includes(campaignId)) {
          await cancelPayment(campaignId, paymentIntent)
        }
        await handleUpdateExtraData({
          campaignId,
          internalStatus: CAMPAIGN_INTERNAL_STATUSES.REJECTED,
          paymentStatus: 'rejected',
          lastActiveStep: isDirectMail ? 'segments' : 'details',
        })
        await insertCampaignLogs([
          {
            campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.DECLINE_CAMPAIGN,
            additionalInfo: sendEmail ? 'with' : 'without',
          },
        ])
        try {
          await updateSelfServeCampaignData({
            campaignId,
            campaignDetailedCosts: null,
          })
        } catch (error) {
          console.error('Error updating self serve campaign data', error)
        }
        if (sendEmail) {
          await handleSaveDeclineCampaignEmail({
            campaignId,
            email: JSON.stringify(data.body.value),
          })
          runSnackBar({
            type: 'success',
            msg: `Email sent! Campaign declined & moved back to Draft`,
          })
        } else {
          runSnackBar({
            type: 'success',
            msg: 'Email NOT sent! Campaign declined & moved back to Draft',
          })
        }
      } catch (error) {
        runSnackBar({
          type: 'error',
          msg: `There was an error while rejecting the campaign, please contact support`,
        })
        console.error({ error })
      }
    }

    if (emailType === EMAIL_TYPE.APPROVE_CAMPAIGN) {
      try {
        if (
          campaignEmailData.subtype !== CAMPAIGN_SUBTYPES_ENUM.EDDM &&
          campaignEmailData.subtype !== CAMPAIGN_SUBTYPES_ENUM.ADM
        ) {
          runSnackBar({
            type: 'success',
            msg: `Creation city plan and missions`,
          })
          const reqIsCreateCityPlanAndMissions = await createCityPlanAndMissionOnSSCampaign(
            {
              campaignId,
            },
          )

          const { data } = await reqIsCreateCityPlanAndMissions.json()

          if (!data.createCityPlanAndMissionOnSSCampaign.success) {
            setCampaignEmailData(null)
            return runSnackBar({
              type: 'error',
              msg: `Cannot create city plan and missions`,
            })
          }
        } else {
          // Handle direct mail campaign approval
          try {
            await handleSetDMCampaignApprovedTask({
              campaignId,
              subtype: campaignEmailData.subtype,
            })
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(
              'Error setting direct mail campaign approved task',
              error,
            )
          }

          if (campaignEmailData.subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM) {
            // TODO: ADD LOGIC FOR CREATING ADM INTERNAL FLYER CODES
            const createCodesRequest = await createEDDMInternalFlyerCodes({
              campaignId,
              clientId,
            })

            const {
              data: {
                createEDDMInternalFlyerCodes: { success },
              },
            } = await createCodesRequest.json()

            if (!success) {
              setCampaignEmailData(null)
              return runSnackBar({
                type: 'error',
                msg: `Cannot create internal flyer codes`,
              })
            }
          }
        }

        if (!skipPayment && !CAMPAIGNS_WITH_NO_PAYMENT.includes(campaignId)) {
          await capturePayment(campaignId, paymentIntent)
        }

        const updateCampaignExtraDataInput = {
          campaignId,
          internalStatus: isMoveInGenerationDigitalProof
            ? CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF
            : CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW,
        }

        const logs = [
          {
            campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.APPROVE_CAMPAIGN,
            additionalInfo: sendEmail ? 'with' : 'without',
          },
        ]

        if (skipPayment) {
          updateCampaignExtraDataInput['paymentStatus'] = 'succeeded'
          logs.push({
            campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.SET_PAYMENT_STATUS,
            additionalInfo: `Payment was skipped status changed to [succeeded]${
              clientIsSkipCheckoutEnabled && !isPaymentSkipped
                ? ' (client-wide skip adm checkout enabled)'
                : ''
            }`,
          })
        }

        await handleUpdateExtraData(updateCampaignExtraDataInput)
        await insertCampaignLogs(logs)
        if (
          campaignEmailData.subtype !== CAMPAIGN_SUBTYPES_ENUM.EDDM &&
          campaignEmailData.subtype !== CAMPAIGN_SUBTYPES_ENUM.ADM
        ) {
          await saveCustomLocations({ campaignId, clientId })
        }
        if (sendEmail) {
          runSnackBar({
            type: 'success',
            msg: `Email sent! Campaign approved & moved to ${
              isMoveInGenerationDigitalProof
                ? 'Generating Digital Proof'
                : 'Code Review'
            }`,
          })
        } else {
          runSnackBar({
            type: 'success',
            msg: `Email NOT sent! Campaign approved & moved to ${
              isMoveInGenerationDigitalProof
                ? 'Generating Digital Proof'
                : 'Code Review'
            }`,
          })
        }

        if (tenant && isXeroAvailable) {
          runSnackBar({
            type: 'success',
            msg: `Starting create Xero data`,
          })

          const xeroData = await apiXero.creatingContactAndItemAndTrackingAndInvoice(
            {
              campaignId: campaignEmailData.campaignId,
              tenantId: tenant.tenantId,
            },
          )
          if (xeroData.success) {
            runSnackBar({
              type: 'success',
              msg: `All Xero data created successfully`,
            })
          } else {
            runSnackBar({
              type: 'error',
              msg: `All Xero data not created successfully`,
            })
          }
        }
      } catch (error) {
        console.error({ error })
      }
    }
    setIsLoadingRequest(false)
    setCampaignEmailData(null)
    cleanFilters()
  }

  const cleanFilters = () => {
    setUrl('city', null)
    setUrl('tableSearch', null)
    setResetSearch(true)
    setSearchValue(null)
    setCityFilter(citiesOptions[0].value)
  }

  const onSendEmail = async ({
    sender: { value: sender },
    recipients: { value: recipients },
    bcc: { value: bcc },
    cc: { value: cc },
    subject: { value: subject },
    body: { value: body },
    isShowToast = true,
    attachments,
  }) => {
    const response = await sendEmail({
      input: {
        sender,
        recipients: splitEmails(recipients),
        bcc: splitEmails(bcc),
        cc: splitEmails(cc),
        subject,
        body: JSON.stringify(body),
        attachments,
      },
    })

    const { data: result } = await response.json()

    const { sendedEmailsTo, failedEmailsTo } = result.sendEmail.reduce(
      (acc, { success, recipient }) => {
        if (!success) {
          if (acc.failedEmailsTo.length) {
            acc.failedEmailsTo += `, ${recipient}`
          } else {
            acc.failedEmailsTo += recipient
          }
        } else {
          if (acc.sendedEmailsTo.length) {
            acc.sendedEmailsTo += `, ${recipient}`
          } else {
            acc.sendedEmailsTo += recipient
          }
        }
        return acc
      },
      { sendedEmailsTo: '', failedEmailsTo: '' },
    )

    if (failedEmailsTo.length) {
      dispatch(
        showReduxModal({
          title: `Error on send email`,
          children: (
            <div className={classes.modalText}>
              {sendedEmailsTo ? (
                <div>{`Successfully send to ${sendedEmailsTo}`}</div>
              ) : null}
              <br />
              <div>
                Cannot send email to{' '}
                <span className={classes.error}>{failedEmailsTo}</span>
              </div>
            </div>
          ),
          confirmLabel: `OK`,
          hideCancel: true,
        }),
      )
    } else {
      if (isShowToast) {
        runSnackBar({
          type: 'success',
          msg: `Email sent successfully`,
        })
      }
    }
  }

  const handleUpdateExtraData = async input => {
    const response = await updateCampaignsCampaignBuilderData({
      input,
    })
    const { data: result } = await response.json()

    if (result.updateCampaignExtraData.success) {
      fetchInitalData()
    } else {
      throw new Error(result.updateCampaignExtraData.error)
    }
  }

  const handleRejectDmCampaign = async ({ campaignId, subtype }) => {
    const isAdm = subtype === CAMPAIGN_SUBTYPES_ENUM.ADM
    const token = authorization.getAPIKey()
    const url = `${CONFIG.API_BASE_URL}/campaigns/us/direct-mail${
      isAdm ? '/adm' : ''
    }/${campaignId}/reject`

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-api-key': token,
      },
    })
    const result = await response.json()

    return result
  }

  const handleSaveDeclineCampaignEmail = async ({ campaignId, email }) => {
    const response = await updateCampaignsCampaignBuilderData({
      input: {
        campaignId,
        declineCampaignEmail: email,
      },
    })
    const { data: result } = await response.json()

    if (result.updateCampaignExtraData.success) {
      fetchInitalData()
    } else {
      throw new Error(result.updateCampaignExtraData.error)
    }
  }

  const handleSendToArchive = async (campaignId, stage) => {
    await updateCampaign({
      campaignId,
      status: STATUS_CAMPAIGN_ENUM_ARCHIVE,
    })
    await insertCampaignLogs([
      {
        campaignId,
        type: CAMPAIGN_LOG_ENUM_TYPES.ARCHIVE_CAMPAIGN,
        additionalInfo: `internal status ${stage}`,
      },
    ])
    fetchInitalData()
    runSnackBar({
      type: 'success',
      msg: `Campaign successfully archived`,
    })
    onCancel()
  }

  const closeModalSendEmail = () => {
    setCampaignEmailData(null)
  }

  const capturePayment = async (campaignId, paymentIntent) => {
    if (!paymentIntent) {
      runSnackBar({
        type: 'error',
        msg: `Missing Stripe Payment Intent error`,
      })
      throw Error('Missing Stripe Payment Intent error')
    }

    const res = await apiClient.capturPayment({
      paymentIntent,
      countryCode,
      campaignId,
      userId: user.id,
    })

    if (res && res.status === 200) {
      const { paymentStatus } = await res.json()
      runSnackBar({
        type: 'success',
        msg: `Payment successful`,
      })
      return await updateCampaignExtraData({
        campaignId,
        paymentStatus,
      })
    }

    runSnackBar({
      type: 'error',
      msg: `Payment error`,
    })
    throw Error('Payment error')
  }

  const refundPayment = async (campaignId, paymentIntent) => {
    const res = await apiClient.refundPayment({
      paymentIntent,
      countryCode,
      campaignId,
      userId: user.id,
    })
    if (res.status === 200) {
      const { paymentStatus } = await res.json()
      runSnackBar({
        type: 'success',
        msg: `Payment refunded`,
      })
      return await updateCampaignExtraData({
        campaignId,
        paymentStatus,
      })
    } else {
      runSnackBar({
        type: 'error',
        msg: `Payment error`,
      })
      throw Error('Payment error')
    }
  }

  const cancelPayment = async (campaignId, paymentIntent) => {
    const res = await apiClient.cancelPayment({
      paymentIntent,
      countryCode,
      campaignId,
      userId: user.id,
    })
    if (res && res.status === 200) {
      const { paymentStatus } = await res.json()
      runSnackBar({
        type: 'success',
        msg: `Payment canceled`,
      })
      return await updateCampaignExtraData({
        campaignId,
        paymentStatus,
      })
    } else {
      runSnackBar({
        type: 'error',
        msg: `Payment error`,
      })
      throw Error('Payment error')
    }
  }

  const handleSetDMCampaignApprovedTask = async ({ campaignId, subtype }) => {
    const isAdm = subtype === CAMPAIGN_SUBTYPES_ENUM.ADM
    const token = authorization.getAPIKey()
    const url = `${CONFIG.API_BASE_URL}/campaigns/us/direct-mail${
      isAdm ? '/adm' : '/eddm'
    }/${campaignId}/set-approve-task`

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-api-key': token,
      },
      body: JSON.stringify({ userId: user.id }),
    })
    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Failed to approve campaign')
    }

    return result
  }

  const getActionsCard = (key, campaign) => {
    const {
      campaignId,
      campaignName,
      isPaymentSkipped,
      paymentIntent,
      internalStatus,
      clientId,
      type,
      subtype,
      workflowId,
    } = campaign

    const OPTIONS = {
      [CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER]: {
        id: 1,
        name: 'Campaign Builder',
        onClick: () => {
          const campaignBuilderPageUrl = getCampaignBuilderPageUrl({
            campaignId,
            clientId,
            lastActiveStep: 'audience',
            channel: type,
            subtype: subtype,
          })
          const url = addAuthParamsToCampaignBuilderUrl(
            campaignBuilderPageUrl,
            clientId,
          )
          openLinkInNewTab(url)
        },
      },
      [CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD]: {
        id: 2,
        name: 'Campaign Dashboard',
        onClick: () => {
          const url = getDashboardPageUrl(campaignId, origin, type, subtype)
          openLinkInNewTab(url)
        },
      },
      [CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL]: {
        id: 3,
        name: 'Email Client',
        onClick: () => {
          setCampaignEmailData({ ...campaign, emailType: EMAIL_TYPE.DEFAULT })
        },
      },
      [CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN]: {
        id: 4,
        name: 'Archive Campaign',
        onClick: () => {
          dispatch(
            showReduxModal({
              title: `Archive the campaign?`,
              children: (
                <div>
                  <div
                    className={classes.modalText}
                  >{`Campaign ${campaignName} will be archived.`}</div>
                  <div className={classes.modalText}>
                    Client will not be able to resume editing this campaign. The
                    client will have to create another campaign if they wish to
                    restart the process
                  </div>
                </div>
              ),
              onConfirm: async () => {
                const clientIsSkipCheckoutEnabled = await getClientSkipCheckoutSetting(
                  clientId,
                )

                const skipPayment = shouldSkipPayment(
                  subtype,
                  isPaymentSkipped,
                  clientIsSkipCheckoutEnabled,
                )
                try {
                  if (
                    !skipPayment &&
                    !CAMPAIGNS_WITH_NO_PAYMENT.includes(campaignId)
                  ) {
                    if (
                      ![
                        CAMPAIGN_INTERNAL_STATUSES.DRAFT,
                        CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW,
                        CAMPAIGN_INTERNAL_STATUSES.REJECTED,
                      ].includes(internalStatus)
                    ) {
                      await refundPayment(campaignId, paymentIntent)
                    }
                    if (
                      internalStatus === CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW
                    ) {
                      await cancelPayment(campaignId, paymentIntent)
                    }
                  }
                  await updateSelfServeCampaignData({
                    campaignId,
                    campaignDetailedCosts: null,
                    internalStatus: CAMPAIGN_INTERNAL_STATUSES.ARCHIVED,
                  })
                  await handleSendToArchive(campaignId, internalStatus)
                  cleanFilters()
                } catch (error) {
                  console.error(error)
                }
              },
              onCancel,
            }),
          )
        },
        style: {
          borderTop: '1px solid #F2F2F2',
        },
      },
      [CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN]: {
        id: 5,
        name: 'Flyer Design',
        onClick: async () => {
          const request = await getCampaignFlyerInfo(campaignId)
          const {
            data: {
              campaignFlyerInfo: { s3Link },
            },
          } = await request.json()
          if (s3Link) {
            openLinkInNewTab(s3Link)
          } else {
            console.error('s3Link is missing')
          }
        },
      },
      [CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT]: {
        id: 6,
        name: 'Send to Draft',
        onClick: () => {
          dispatch(
            showReduxModal({
              title: `Move campaign back to Draft?`,
              children: (
                <div>
                  <div
                    className={classes.modalText}
                  >{`Campaign: ${campaignName}`}</div>
                  <div className={classes.modalText}>
                    This campaign will be moved back to Draft status. Any
                    progress made through the campaign pipeline will be lost
                    (data such as codes will remain). The client will have to
                    re-submit the campaign if they wish to restart the approval
                    process.
                  </div>
                </div>
              ),
              onConfirm: async () => {
                try {
                  await refundPayment(campaignId, paymentIntent)
                  await updateSelfServeCampaignData({
                    campaignId,
                    campaignDetailedCosts: null,
                  })
                  await handleUpdateExtraData({
                    campaignId,
                    internalStatus: CAMPAIGN_INTERNAL_STATUSES.DRAFT,
                  })
                  runSnackBar({
                    type: 'success',
                    msg: `Campaign successfully moved to Draft`,
                  })
                  onCancel()
                  cleanFilters()
                } catch (error) {
                  console.error(error)
                }
              },
              onCancel,
            }),
          )
        },
      },
      [CAMPAIGN_CARD_ACTIONS.APPROVE_CAMPAIGN]: {
        id: 8,
        name: 'Approve campaign',
        onClick: async () => {
          const url = getCodesPageUrl(campaignId, origin)
          setCampaignEmailData({
            ...campaign,
            emailType: EMAIL_TYPE.APPROVE_CAMPAIGN,
            codesPageUrl: url,
            paymentIntent,
          })
        },
        style: {
          color: '#31955F',
        },
      },
      [CAMPAIGN_CARD_ACTIONS.DECLINE_CAMPAIGN]: {
        id: 9,
        name: 'Decline campaign',
        onClick: () => {
          const url = getClientDashboardPageUrl(campaignId, origin)
          setCampaignEmailData({
            ...campaign,
            emailType: EMAIL_TYPE.DECLINE_CAMPAIGN,
            clientDashboardUrl: url,
            paymentIntent,
          })
        },
        style: {
          color: '#EE4343',
          borderBottom: '1px solid #F2F2F2',
        },
      },
      [CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER_EDIT]: {
        id: 10,
        name: 'Edit campaign',
        onClick: () => {
          const campaignBuilderPageUrl = getCampaignBuilderPageUrl({
            campaignId,
            clientId,
            lastActiveStep: 'audience',
            channel: type,
            subtype: subtype,
          })

          const url = addAuthParamsToCampaignBuilderUrl(
            campaignBuilderPageUrl,
            clientId,
          )

          openLinkInNewTab(url)
        },
      },
      [CAMPAIGN_CARD_ACTIONS.CODES_PAGE]: {
        id: 11,
        name: 'Codes Page',
        onClick: () => {
          const url = getCodesPageUrl(campaignId, origin)
          openLinkInNewTab(url)
        },
        style: {
          borderBottom: '1px solid #F2F2F2',
        },
      },
      [CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE]: {
        id: 12,
        name: 'Internal Files Page',
        onClick: () => {
          const url = getDigitalProofPageUrl(campaignId, origin)
          openLinkInNewTab(url)
        },
        style: {
          borderBottom: '1px solid #F2F2F2',
        },
      },
      [CAMPAIGN_CARD_ACTIONS.ACTIVATE_CAMPAIGN]: {
        id: 8,
        name: 'Activate campaign',
        onClick: async () => {
          await handleUpdateExtraData({
            campaignId,
            internalStatus: CAMPAIGN_INTERNAL_STATUSES.ACTIVE,
          })
          await updateCampaign({
            campaignId,
            status: STATUS_CAMPAIGN_ENUM_ACTIVE,
          })
          await insertCampaignLogs([
            {
              campaignId,
              type: CAMPAIGN_LOG_ENUM_TYPES.ACTIVATE_CAMPAIGN,
            },
          ])
          cleanFilters()
        },
        style: {
          borderBottom: '1px solid #F2F2F2',
        },
      },
    }

    const options = campaignCardOptions[key]
      .filter(currentOption => {
        if (workflowId) {
          return (
            currentOption !== CAMPAIGN_CARD_ACTIONS.DECLINE_CAMPAIGN &&
            currentOption !== CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER
          )
        }
        if (CAMPAIGN_BUILDER_CARD_OPTIONS.has(currentOption)) {
          return canNavigateCampaignBuilder
        }
        return true
      })
      .map(currentOption => OPTIONS[currentOption])

    return options
  }

  return (
    <div className={classes.wrap}>
      <div className={classes.wrapForm}>
        {confirmDialogData.isOpen && <ConfirmDialog {...confirmDialogData} />}
        <EmailModal
          open={!!campaignEmailData}
          controlModal={closeModalSendEmail}
          user={user}
          onSubmit={onSubmit}
          emailId={1}
          data={campaignEmailData}
          isLoadingRequest={isLoadingRequest}
        />
        <Grid
          xs={12}
          spacing={2}
          display="flex"
          alignItems="flex-end"
          container
        >
          <Grid xs={3} item className={classes.searchWrap}>
            <SearchInput
              reset={resetSearch}
              setReset={setResetSearch}
              placeholder="Search"
              searchHandler={handlerSearch}
            />
          </Grid>
          <Grid xs={2} item>
            <SelectDashboard
              label="Cities"
              options={citiesOptions}
              value={cityFilter}
              onChange={onChangeCityFilter}
            />
          </Grid>
          {!isLoading && isXeroAvailable ? (
            <Grid xs={6} item>
              <div className={classes.xeroConnectionWrapper}>
                <div className={classes.mr30}>
                  <div className={classes.flexCenter}>
                    <span className={classes.mr6}>Xero Status:</span>
                    <XeroConnected isConnected={tenant} />
                  </div>
                  <div>{xeroInfo}</div>
                </div>
                <SubmitButton
                  variant="contained"
                  value="Xero Settings"
                  onClick={() => {
                    openLinkInNewTab(
                      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                        PATHS.settings.xeroConnection
                      }`,
                    )
                  }}
                />
              </div>
            </Grid>
          ) : null}

          <Grid
            xs={isXeroAvailable ? 1 : 7}
            container
            justifyContent="flex-end"
          >
            {!isLoading && (
              <SubmitButton
                variant="contained"
                value="Export"
                onClick={() =>
                  onExportData(filteredPipelines || pipelines, countryName)
                }
                className={classes.button}
              />
            )}
          </Grid>
        </Grid>
      </div>
      {isLoading || !Object.entries(filteredPipelines || pipelines).length ? (
        <Progress />
      ) : (
        <DragDropContext onDragEnd={() => {}}>
          <div className={classes.view}>
            {Object.entries(filteredPipelines || pipelines).map(
              ([key, value], index) => (
                <PipelineColumn
                  key={`${index}-${value.length}`}
                  items={value}
                  stage={key}
                  getActionsCard={getActionsCard}
                />
              ),
            )}
          </div>
        </DragDropContext>
      )}
    </div>
  )
}

export default memo(withStyles(style)(CampaignPipelineView))
